// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResourcesSlider_wrapper","content":"ResourcesSlider_content"};